import { render, staticRenderFns } from "./PrimaryBtn.vue?vue&type=template&id=430edcfe&scoped=true&lang=pug"
import script from "./PrimaryBtn.vue?vue&type=script&lang=js"
export * from "./PrimaryBtn.vue?vue&type=script&lang=js"
import style0 from "./PrimaryBtn.vue?vue&type=style&index=0&id=430edcfe&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430edcfe",
  null
  
)

export default component.exports